import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Create';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, IconButton, Stack, styled, Tooltip } from '@mui/material';

interface EditModeButtonProps {
  editMode: boolean;
  loading?: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
}

const EditModeButton = ({
  editMode,
  loading = false,
  onEdit,
  onSave,
  onCancel,
}: EditModeButtonProps) => {
  if (editMode) {
    return (
      <ButtonContainer>
        <Stack direction="row" spacing={1}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            onClick={onSave}
            disabled={loading}
          >
            {loading ? '저장 중...' : '저장'}
          </Button>
          <Button
            variant="outlined"
            color="inherit"
            startIcon={<CloseIcon />}
            onClick={onCancel}
            disabled={loading}
          >
            취소
          </Button>
        </Stack>
      </ButtonContainer>
    );
  }

  return (
    <ButtonContainer>
      <Tooltip title="직원 배치 수정">
        <IconButton
          onClick={onEdit}
          sx={{
            bgcolor: 'background.paper',
            boxShadow: 1,
            '&:hover': { bgcolor: 'action.hover' },
          }}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    </ButtonContainer>
  );
};

export default EditModeButton;

const ButtonContainer = styled(Box)(() => ({
  position: 'absolute',
  top: 20,
  right: 20,
  zIndex: 100,
}));
